export default "__VITE_ASSET__CGQSPKAB__"